// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-form-search-trailer[data-v-4e52aa64] {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.5rem/* 24px */;\n}\n.col-span-2[data-v-4e52aa64] {\n    grid-column: span 2 / span 2;\n}\n\n", ""]);
// Exports
module.exports = exports;
